module.exports = __webpack_public_path__ + "static/media/dresser-removal.700817e6.svg";